import { type ReactNode } from 'react';
import type { AccountStatus } from '../types';

// 'deleted' intentionally omitted — use the Archive button, not this dropdown.
// 'redemption_test' intentionally omitted — set by user clicking "Intentar
// redención" on the Game Over page, not by admin override (per fase 28).
const STATUSES: AccountStatus[] = [
  'healthy',
  'test',
  'pre_banned',
  'banned',
  'failed',
];
const LABELS: Record<AccountStatus, string> = {
  test: 'Prueba',
  healthy: 'Activo',
  pre_banned: 'Pre-ban',
  redemption_test: 'Redención',
  banned: 'Baneado',
  failed: 'Fallido',
  deleted: 'Archivado',
};

const SEL =
  'w-full rounded-md border border-white/[0.06] bg-surface px-sm py-1.5 text-xs text-text-secondary';
const TA = SEL + ' placeholder:text-text-tertiary';

export function StatusSelect({
  value,
  onChange,
}: {
  value: AccountStatus;
  onChange: (v: AccountStatus) => void;
}): ReactNode {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as AccountStatus)}
      className={SEL}
    >
      {STATUSES.map((s) => (
        <option key={s} value={s}>
          {LABELS[s]}
        </option>
      ))}
    </select>
  );
}

export function ReasonInput({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}): ReactNode {
  return (
    <textarea
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder="Motivo del cambio (obligatorio)"
      rows={2}
      className={TA}
    />
  );
}

type FS = { status: AccountStatus; reason: string; confirmed: boolean };

export function ConfirmCheck({
  s,
  setS,
  label,
}: {
  s: FS;
  setS: (s: FS) => void;
  label: string;
}): ReactNode {
  return (
    <label className="flex items-center gap-xs text-xs text-warning">
      <input
        type="checkbox"
        checked={s.confirmed}
        onChange={(e) => setS({ ...s, confirmed: e.target.checked })}
      />
      {label}
    </label>
  );
}
